/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import { ApplicationStatus } from "./application-types"
import { FLAG_SEPARATOR } from "./device-flags"

export function getStatusFromUrl(params: URLSearchParams): ApplicationStatus | null {
    const raw = params.get("status")
    if (!raw) return null

    const upper = raw.toUpperCase()
    return Object.values(ApplicationStatus).includes(upper as ApplicationStatus) ? (upper as ApplicationStatus) : null
}

export function getFlagsFromUrl(search: URLSearchParams): string[] {
    return (search.get("flags") ?? "")
        .split(FLAG_SEPARATOR)
        .filter(Boolean)
        .map((f) => f.toUpperCase())
}

export function getPageFromUrl(search: URLSearchParams): number {
    const raw = search.get("page")
    const page = parseInt(raw ?? "", 10)
    return Number.isNaN(page) || page <= 1 ? 0 : page - 1
}

export function getAppTypeIdFromParams(params?: { id?: string }): number | null {
    const id = params?.id
    const num = id ? Number(id) : NaN
    return Number.isNaN(num) ? null : num
}

export function updateApplicationUrlSearchParams(flags: string[], page: number): void {
    const params = new URLSearchParams(window.location.search)

    if (flags.length > 0) {
        params.set("flags", flags.join(FLAG_SEPARATOR))
    } else {
        params.delete("flags")
    }

    if (page > 0) {
        params.set("page", String(page + 1)) // convert to 1-based for URL
    } else {
        params.delete("page")
    }

    window.history.replaceState({}, "", `${window.location.pathname}?${params.toString()}`)
}
